import React from "react";
import "./Synonym.css";

export default function Synonyms(props){
    if (props.synonyms){
        return (
            <ul className="Synonym">
            {props.synonyms.map(function (synonyms, index) {
                return (
                    <li key={index}>
                    {synonyms}
                    </li>
                );
            })}
            </ul>
            );
    } else { 
    return (null);
    }
}